import { get } from "@ember/object"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookEditTemplates } from "@shared/models/analytics/planbook"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import Patch from "@shared/models/patch-updater"
import _ from "lodash"
import { COURSE_DATE_SAVE_AS_TEMPLATE } from "../course/calendar/COURSE_DATE_SAVE_AS_TEMPLATE"
import type { Narrative } from "@shared/actions/create-narrative"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

export const PLANBOOK_CREATE_LESSON_TEMPLATE = {
  name: "PLANBOOK_CREATE_LESSON_TEMPLATE",
  // Please change lessonAttributes to match payload of COURSE_DATE_EDIT_TEMPLATE
  params: {
    newId: "string",
    planbookId: "string",
    lessonAttributes: "object",
    assignTemplatePatches: "array",
    assignTemplateUndoPatches: "array",
  },

  patches(payload) {
    return _.concat(COURSE_DATE_SAVE_AS_TEMPLATE.patches(payload), payload.assignTemplatePatches)
  },

  undoPatches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).pull(
      "relationships.cardStackTemplates.data",
      {
        id: payload.newId,
        type: "card-stack",
      }
    ).patch

    return _.concat([patch], payload.assignTemplateUndoPatches)
  },

  narrative(payload, findFn, userId): Narrative {
    let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)
    let planbook = get(models, "planbook")
    let planbookTitle = get(get(planbook, "attributes"), "title")
    let newEvent: PlanbookEditTemplates = {
      ...createBlankEvent(),
      root_id: payload.planbookId,
      root_type: "planbook",
      primary_object_id_and_ancestor_ids: [payload.planbookId],
      primary_object_type: "planbook",
      primary_verb: "edit",
      primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbookId),
      primary_object_specifier: "templates",
      adverbial_verb: "adding",
      adverbial_object_type: "template",
    }

    return {
      title: "Created New Template",
      titleForAnalytics: "Planbook - Create Template",
      description: `Added a new template to your ${planbookTitle} planbook`,
      context: defaultPlanbookContext(payload, models),
      activity: defaultPlanbookActivity(payload, models),
      newAnalyticsEvents: [newEvent],
    }
  },
}

export default PLANBOOK_CREATE_LESSON_TEMPLATE
